/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Registry_Isir_LookupInputs */

const cs_property_registry_isir_lookup = /** @type {(inputs: Property_Registry_Isir_LookupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zkontrolovat ISIR`)
};

const en_property_registry_isir_lookup = /** @type {(inputs: Property_Registry_Isir_LookupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check ISIR`)
};

/**
* | output |
* | --- |
* | "Check ISIR" |
*
* @param {Property_Registry_Isir_LookupInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_registry_isir_lookup = /** @type {((inputs?: Property_Registry_Isir_LookupInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Registry_Isir_LookupInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_registry_isir_lookup(inputs)
	return cs_property_registry_isir_lookup(inputs)
});